/* src/app/admin/popi/popi.component.scss */
.simple-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
.simple-table th,
.simple-table td {
  border: 1px solid #ddd;
  padding: 8px;
}
.simple-table th {
  background-color: #006f8a;
  color: white;
  text-align: left;
}
.simple-table tr:nth-child(even) {
  background-color: #f2f2f2;
}
.error-panel {
  background-color: #ffe5e5;
  border: 1px solid #ff9999;
  padding: 12px;
  border-radius: 6px;
  margin-top: 10px;
  margin-bottom: 15px;
}
.warn-panel {
  background-color: #fffae5;
  border: 1px solid #ff9999;
  padding: 12px;
  border-radius: 6px;
  margin-top: 10px;
  margin-bottom: 15px;
}
.loader-wrapper {
  position: relative;
  width: 100px;
  height: 20px;
}
.bar-loader {
  width: 100%;
  height: 4px;
  background:
    linear-gradient(
      to right,
      #3498db 30%,
      #f3f3f3 30%);
  background-size: 200% 100%;
  animation: bar-slide 1.5s linear infinite;
  margin-top: 16px;
}
.loading-text {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  font-size: 12px;
  color: #555;
}
/*# sourceMappingURL=popi.component-WHJPUOS7.css.map */
